<template>
  <div
    class="size-controller-wrapper d-flex justify-content-between flex-column"
    @click.stop="stopPropegation()">
    <label class="mb-4">{{ label }}</label>
    <div class="size-select-button d-flex justify-content-between align-items-center rounded-4 py-5 px-16 border border-1 border-light-gray">
      <button
        :disabled="disableFloatDecrement"
        class="change-btn border-0 bg-transparent "
        @click.stop="zoomOut()">
        <icon name="minus-decrement" />
      </button>
      <div class="input-wrapper d-flex justify-content-center">
        <input
          v-model="getValue"
          type="number"
          class="zoom-amount border-0 bg-transparent w-0 text-center d-block"
          @keyup.enter="changeTypedValue($event)" >
      </div>
      <button
        class="change-btn border-0 bg-transparent "
        @click.stop="zoomIn()">
        <icon name="plus-increment"/>
      </button>
    </div>
  </div>
</template>
<script>
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes'; // TDOD: Change to @/
import EventBus from '../../EventBus';

export default {
  name: 'SizeAdjustButton',

  filters: {

  },
  props: {
    label: String,
    value: { default: 0 },
    scale: Number,
  },
  data() {
    return {
      disableFloatDecrement: false,
      inputValue:            this.value,
      isMouseDown:           0,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(next) {
        if (next === undefined || next === null || Number.isNaN(Number(next))) {
          return;
        }
        this.inputValue = next;
        this.disableFloatDecrement = parseFloat(next) === 0;
      },
    },
  },
  computed: {
    getPlusTooltip() {
      return `Increase ${this.label}`;
    },
    getMinusTooltip() {
      return `Decrease ${this.label}`;
    },
    getValue: {
      get() {
        if (this.label === 'Line Spacing') {
          return parseFloat(this.inputValue).toFixed(1);
        }
        if (this.label === 'Size') {
          return Math.round(this.inputValue * this.scale);
        }
        return this.inputValue;
      },
      set(value) {
        // if (this.inputValue > value)
        // {
        //    this.inputValue = value
        //    this.zoomOut()
        // }
        // else
        //   {
        //   this.inputValue= value
        //   this.zoomIn()
        //  }
      },

    },
  },

  methods: {
    stopPropegation() {},
    zoomIn() {
      if (this.label === 'Line Spacing') {
        this.inputValue = parseFloat(this.inputValue) + 0.1;
        this.inputValue = parseFloat(this.inputValue).toFixed(1);
        if (!this.isMouseDown) {
          this.isMouseDown = setInterval(() => this.inputValue += 0.1, 30);
        }
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_LINE_HEIGHT, this.inputValue);
        // console.log(typeof this.value);
      }
      if (this.label === 'Size') {
        this.inputValue += (1 / this.scale);
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_SIZE, this.inputValue, 'increment');
      }

      // this.changeValue(this.inputValue);
      this.disableFloatDecrement = false;
    },

    retrieveZoom() {
      clearInterval(this.isMouseDown);
      this.isMouseDown = 0;
    },

    zoomOut() {
      if (parseFloat(this.inputValue) > 0) {
        if (this.label === 'Line Spacing') {
          this.inputValue = parseFloat(this.inputValue) - 0.1;
          this.inputValue = parseFloat(this.inputValue).toFixed(1);
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_LINE_HEIGHT, this.inputValue);
        } else if (this.label === 'Size') {
          this.inputValue -= (1 / this.scale);
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_SIZE, this.inputValue, 'decrement');
        }
      }
      parseFloat(this.inputValue) === 0 ? this.disableFloatDecrement = true : '';
    },
    changeTypedValue(e) {
      if (this.label === 'Size') {
        this.inputValue = (parseFloat(e.target.value) / this.scale);
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_SIZE, this.inputValue);
      } else if (this.label === 'Line Spacing') {
        this.inputValue = e.target.value;
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_LINE_HEIGHT, Number(parseFloat(this.inputValue).toFixed(1)));
      }
    },

  },
};

</script>
<style lang="scss">
  .input-wrapper{
    input[type="number"]{
      width: 56px;
    }
  }
  .change-btn{
    opacity: 0.7;
    &:hover{
      opacity: 1;
    }
  }


  .zoom-out[disabled="disabled"] {
    svg {
      path {
        fill: $grey40 !important;
      }
    }
  }
</style>
